/**
 * Οθόνη αφής: μετά το σήκωμα του δαχτύλου ο browser στέλνει ΚΑΙ ένα «click», με νέο έλεγχο του τι
 * βρίσκεται εκείνη τη στιγμή κάτω από το δάχτυλο. Όταν το κουμπί κάνει την ενέργειά του στο
 * pointerup (κράτημα 2″ = εκπαίδευση) και ανοίγει παράθυρο, το click πέφτει στο σκούρο φόντο του
 * καινούργιου παραθύρου και το κλείνει αμέσως. Αυτό ήταν το «τα Μετρητά δεν δουλεύουν με την
 * οθόνη αφής» της 15/10/2026. Με ποντίκι δεν συμβαίνει: εκεί το click πάει στο στοιχείο του πατήματος.
 *
 * Κάλεσέ το σε κάθε onPointerUp που ΚΑΝΕΙ την ενέργεια. Τρώει το ΕΠΟΜΕΝΟ click, μόνο για αφή ή
 * γραφίδα, μόνο στο ίδιο σημείο και μόνο για λίγο. Ένα άλλο πάτημα αλλού περνά κανονικά.
 */
export const GHOST_CLICK_MS = 800;
export const GHOST_CLICK_RADIUS_PX = 40;

interface PointerLike {
  pointerType?: string;
  clientX: number;
  clientY: number;
}

/** Το επόμενο click της αφής στο ίδιο σημείο: `swallow(click)` αποφασίζει αν θα φαγωθεί. */
function guardNextTouchClick(e: PointerLike, swallow: (ev: MouseEvent) => boolean): void {
  if (typeof window === 'undefined') return;
  if (!e.pointerType || e.pointerType === 'mouse') return;
  const x = e.clientX;
  const y = e.clientY;
  let timer = 0;
  const done = () => {
    window.clearTimeout(timer);
    window.removeEventListener('click', onClick, true);
  };
  function onClick(ev: MouseEvent) {
    if (Math.abs(ev.clientX - x) > GHOST_CLICK_RADIUS_PX || Math.abs(ev.clientY - y) > GHOST_CLICK_RADIUS_PX) return;
    done();
    if (!swallow(ev)) return;
    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();
  }
  window.addEventListener('click', onClick, true);
  timer = window.setTimeout(done, GHOST_CLICK_MS);
}

export function swallowGhostClick(e: PointerLike): void {
  guardNextTouchClick(e, () => true);
}

/**
 * Πλακίδιο προϊόντος: το παρατεταμένο πάτημα ανοίγει το παράθυρο επιλογών ΕΝΩ το δάχτυλο είναι
 * ακόμη κάτω. Στο σήκωμα, το click της αφής πέφτει σε ό,τι άνοιξε από κάτω — ένα υλικό, μια
 * επιλογή — και το πατούσε μόνο του (βρέθηκε με αληθινά αγγίγματα, 16/10/2026). Κάλεσέ το στο
 * onPointerUp του πλακιδίου: το click περνά μόνο αν πέσει πάλι ΜΕΣΑ στο πλακίδιο (το κανονικό
 * πάτημα), αλλιώς φαγώνεται.
 */
export function keepTouchClickOn(e: PointerLike, el: Element | null): void {
  if (!el) return;
  guardNextTouchClick(e, ev => !(ev.target instanceof Node && el.contains(ev.target)));
}
